var _path, _rect, _rect2, _path2, _path3, _path4, _g, _rect3, _ellipse, _ellipse2, _rect4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaleWithEggInBeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 192,
    viewBox: "0 0 170 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2968 100.02C12.4876 98.1619 14.8232 97 17.3671 97H152.633C155.177 97 157.512 98.1619 158.703 100.02L167.529 113.791C169.044 116.154 166.971 119 163.735 119H6.26463C3.02878 119 0.955955 116.154 2.47064 113.791L11.2968 100.02Z",
    fill: "#CCCCCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151.3,
    y: 187.114,
    width: 17.5879,
    height: 4.20218,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.96533,
    y: 186.47,
    width: 17.5879,
    height: 4.20218,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96533 145.944C1.96533 129.958 14.9238 117 30.9089 117H140.074C156.059 117 169.017 129.958 169.017 145.944V188H1.96533V145.944Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 120.648C0 115.32 4.3195 111 9.64787 111H160.352C165.68 111 170 115.319 170 120.648V186H0V120.648Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.364 169.104C149.364 174.432 145.045 178.752 139.716 178.752L29.3011 178.752C23.9727 178.752 19.6532 174.432 19.6532 169.104L19.6532 118.935L149.364 118.935L149.364 169.104Z",
    fill: "#CCD8E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10295_35519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.416 122H22.6012V154.16H146.416V122Z",
    fill: "#173E50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.7557 122L34.1786 154.16H72.6149L132.587 122H93.7557Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.079 122L75.986 154.16H80.1777L139.662 122H135.079Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.783 122H23.8875C23.1771 122 22.6012 122.576 22.6012 123.286V154.544C22.6012 155.254 23.1771 155.83 23.8875 155.83H147.783C148.493 155.83 149.069 155.254 149.069 154.544V123.286C149.069 122.576 148.493 122 147.783 122Z",
    stroke: "#031D29",
    strokeWidth: 2.57277,
    strokeMiterlimit: 10
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.1409,
    y: 101.569,
    width: 34.8025,
    height: 6.43191,
    fill: "#333333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2258,
    cy: 95.137,
    rx: 62.6445,
    ry: 11.5774,
    fill: "#838383"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5422,
    cy: 93.2075,
    rx: 63.5937,
    ry: 12.2206,
    fill: "#5C5C5C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 157.527,
    width: 39.8439,
    height: 18.0094,
    rx: 2.25117,
    fill: "#A41034",
    stroke: "#C87085",
    strokeWidth: 1.28638
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10295_35519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 156,
    width: 43,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.02 156.884V161.386V183.898H69.3579V176.18H64.8555L69.3579 171.677V161.386H101.517L106.02 156.884Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10295_35519)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 157.527,
    width: 39.8439,
    height: 18.0094,
    rx: 2.25117,
    stroke: "#830D2A",
    strokeWidth: 1.28638
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3953 169.976V168.922L79.1957 165.014H76.5574V163.852H80.8706V164.897L78.0702 168.814H80.9426V169.976H76.3953ZM83.7832 170.084C82.3605 170.084 81.6401 169.408 81.6401 168.085V167.166C81.6401 165.86 82.3605 165.167 83.7292 165.167C85.1069 165.167 85.8273 165.878 85.8273 167.184V168.04H82.9728V168.13C82.9728 168.742 83.2159 169.039 83.7922 169.039C84.2424 169.039 84.5036 168.859 84.5306 168.535H85.8003C85.7462 169.552 85.0529 170.084 83.7832 170.084ZM82.9728 167.103H84.5666C84.5666 166.473 84.3325 166.212 83.7742 166.212C83.2069 166.212 82.9728 166.473 82.9728 167.103ZM86.7884 169.976V165.275H87.923L87.977 166.149C88.1571 165.482 88.5263 165.185 89.1746 165.185H89.5258V166.428H89.2737C88.5803 166.428 88.2471 166.689 88.1211 167.346V169.976H86.7884ZM92.1457 170.084C90.723 170.084 90.0116 169.408 90.0116 168.058V167.193C90.0116 165.842 90.723 165.167 92.1457 165.167C93.5685 165.167 94.2798 165.842 94.2798 167.193V168.058C94.2798 169.408 93.5685 170.084 92.1457 170.084ZM92.1457 169.003C92.713 169.003 92.9472 168.715 92.9472 168.031V167.22C92.9472 166.536 92.713 166.248 92.1457 166.248C91.5784 166.248 91.3443 166.536 91.3443 167.22V168.031C91.3443 168.715 91.5784 169.003 92.1457 169.003Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.579 18.6781C121.125 19.5061 120.054 19.9312 119.046 19.6851L117.71 19.3494C113.974 20.8004 113.113 22.1525 113 26.5V87.3538C113 89.4461 111.417 91 109.06 91H61.5059C59.1363 91 57 89.4461 57 87.3538L56.6415 15.2107C56.6415 13.6891 56.1121 12.3342 55.1542 11.0587C54.65 10.0965 55.4441 9 56.6415 9H106.429C111.811 9 116.953 10.958 120.659 14.4041C122.008 15.4894 122.386 17.2348 121.579 18.6781Z",
    fill: "#D9ECF6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8052 46C95.384 45.9765 102.059 63.2931 99.4245 74.2685C97.0937 83.9871 90.3985 86 85.039 86C79.6795 86 73.1713 83.3855 70.6535 74.6449C67.7417 64.5231 74.9344 46.0235 84.8052 46Z",
    fill: "#F2A05B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7342 54.24C75.4653 56.2798 74.1863 58.8472 73.9125 60.9878C73.4116 64.9297 76.2934 65.3733 77.2985 63.4175C78.3036 61.4617 79.3321 59.4823 80.965 56.8578C83.2223 53.2318 86.9189 50.8022 85.1023 49.2261C83.2858 47.65 79.3989 49.952 76.7342 54.24Z",
    fill: "#FECC88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1451 59.822C94.5177 59.822 94.8197 59.5121 94.8197 59.1298C94.8197 58.7474 94.5177 58.4375 94.1451 58.4375C93.7726 58.4375 93.4706 58.7474 93.4706 59.1298C93.4706 59.5121 93.7726 59.822 94.1451 59.822Z",
    fill: "#D47858"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9036 76.3709C95.0572 75.995 94.8804 75.5655 94.5085 75.4116C94.1367 75.2577 93.7108 75.4376 93.5571 75.8135C93.4035 76.1894 93.5804 76.6189 93.9522 76.7728C94.324 76.9267 94.75 76.7468 94.9036 76.3709Z",
    fill: "#D47858"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.243 79.3167C75.3861 78.9666 75.22 78.566 74.8721 78.422C74.5242 78.2779 74.1261 78.445 73.983 78.7952C73.8399 79.1453 74.0059 79.546 74.3538 79.69C74.7018 79.834 75.0999 79.6669 75.243 79.3167Z",
    fill: "#D47858"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6474 66.3148C97.1501 66.0526 97.3718 65.4794 97.1427 65.0345C96.9137 64.5896 96.3204 64.4414 95.8177 64.7036C95.315 64.9657 95.0933 65.5389 95.3223 65.9838C95.5514 66.4287 96.1447 66.5769 96.6474 66.3148Z",
    fill: "#D47858"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9203 75.3353C87.4229 75.0731 87.6447 74.4999 87.4156 74.055C87.1865 73.6101 86.5933 73.4619 86.0906 73.7241C85.5879 73.9862 85.3661 74.5594 85.5952 75.0043C85.8243 75.4492 86.4176 75.5974 86.9203 75.3353Z",
    fill: "#D47858"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.965 80.1085C86.3364 79.6398 86.3219 79.0066 85.9326 78.6942C85.5433 78.3817 84.9266 78.5084 84.5552 78.9771C84.1838 79.4457 84.1983 80.079 84.5876 80.3914C84.9769 80.7038 85.5936 80.5772 85.965 80.1085Z",
    fill: "#D47858"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9822 81.2195C82.4209 80.723 82.39 79.9745 81.9132 79.5478C81.4363 79.1211 80.6941 79.1777 80.2554 79.6742C79.8167 80.1707 79.8476 80.9192 80.3244 81.3459C80.8012 81.7726 81.5435 81.716 81.9822 81.2195Z",
    fill: "#D47858"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 16C61 15.4477 61.4477 15 62 15H71C71.5523 15 72 15.4477 72 16C72 16.5523 71.5523 17 71 17H63V29H71C71.5523 29 72 29.4477 72 30C72 30.5523 71.5523 31 71 31H63V43H71C71.5523 43 72 43.4477 72 44C72 44.5523 71.5523 45 71 45H63V57H71C71.5523 57 72 57.4477 72 58C72 58.5523 71.5523 59 71 59H63V71H71C71.5523 71 72 71.4477 72 72C72 72.5523 71.5523 73 71 73H63V85H71C71.5523 85 72 85.4477 72 86C72 86.5523 71.5523 87 71 87H62C61.4477 87 61 86.5523 61 86V72V58V44V30V16Z",
    fill: "#668BA6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 14,
    width: 13,
    height: 73,
    rx: 3,
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10295_35519"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.6012,
    y: 122,
    width: 123.815,
    height: 32.1596,
    rx: 1.28638,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleWithEggInBeaker);
export default __webpack_public_path__ + "static/media/scale_with_egg_in_beaker.6902e9b903461a42421b46fcbf773d9f.svg";
export { ForwardRef as ReactComponent };